module.exports = __webpack_public_path__ + "static/images/dandan.2ZIraN_.svg";